import { AnalyticsTransformer, TrackingData } from '@panamax/app-state';

export const viewExceptionLinkTraceTransformer: AnalyticsTransformer = (
  trackingData: TrackingData,
) => ({
  event: trackingData.data.attributes?.event,
  order: {
    id: trackingData.data.attributes?.id,
    tandemOrderNumber: trackingData.data.attributes?.tandemOrderNumber,
  },
});
export const myOrdersCallTransformer: AnalyticsTransformer = (
  trackingData: TrackingData,
) => ({
  ...trackingData.data.attributes,
});
